import type { IconData } from '@stacksjs/iconify-core'

export const mg4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#fc3d32\" d=\"M213.3 0H640v240H213.3z\"/><path fill=\"#007e3a\" d=\"M213.3 240H640v240H213.3z\"/><path fill=\"#fff\" d=\"M0 0h213.3v480H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default mg4x3
